/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './ConsentModal.scss';
import React from 'react';

import BaseModal from 'components/shared/Modal/BaseModal';

const ConsentModal = ({
  close,
  hideAnchor,
  hideClose = false,
  title,
  isOpen,
  containerClassName,
  children
}) => (
  <BaseModal
    close={close}
    containerClassName={containerClassName}
    hideAnchor={hideAnchor}
    hideClose={hideClose}
    title={title}
    renderTitleContent={title}
    label="consent-overlay-modal"
    disableClickOff
    isOpen={isOpen}>
    <div>{children}</div>
  </BaseModal>
);

ConsentModal.defaultProps = {
  containerClassName: 'consent-modal-container'
};

export default ConsentModal;
